import { useState } from "react";
import IntranetLayout from "@/components/IntranetLayout";
import { Card, CardContent } from "@/components/ui/card";
import { X, Ship, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { VESSEL_CATALOGUE } from "@/data/portalMockData";

const CatalogueCard = ({ v }: { v: typeof VESSEL_CATALOGUE[0] }) => {
  const [showLightbox, setShowLightbox] = useState(false);
  return (
    <Card className="overflow-hidden">
      <div className="w-full overflow-hidden cursor-pointer group relative" onClick={() => setShowLightbox(true)}>
        <img src={v.image} alt={v.name} className="w-full h-[260px] object-cover transition-transform duration-500 group-hover:scale-105" loading="eager" />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
          <span className="opacity-0 group-hover:opacity-100 transition-opacity text-white text-xs font-semibold bg-black/50 px-3 py-1.5 rounded-full backdrop-blur-sm">Click to enlarge</span>
        </div>
      </div>
      {showLightbox && (
        <div className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-4 cursor-pointer" onClick={() => setShowLightbox(false)}>
          <button className="absolute top-4 right-4 text-white/80 hover:text-white z-10" onClick={() => setShowLightbox(false)}>
            <X className="w-8 h-8" />
          </button>
          <img src={v.image} alt={v.name} className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl" onClick={e => e.stopPropagation()} />
          <div className="absolute bottom-6 left-0 right-0 text-center">
            <p className="text-white font-bold text-lg">{v.name}</p>
            <p className="text-white/60 text-xs uppercase tracking-[2px]">{v.type}</p>
          </div>
        </div>
      )}
      <CardContent className="p-5 space-y-3">
        <div>
          <h3 className="font-display text-lg text-foreground">{v.name}</h3>
          <p className="text-[11px] font-semibold uppercase tracking-[2px] text-teal mt-0.5">{v.type}</p>
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed">{v.description}</p>
        <div className="grid grid-cols-2 gap-2">
          {v.specs.map(spec => (
            <div key={spec.label} className="p-2 rounded bg-muted/50">
              <p className="text-[9px] text-muted-foreground uppercase tracking-wider">{spec.label}</p>
              <p className="text-xs font-medium text-foreground">{spec.value}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

const EmployeeVesselCatalogue = () => {
  return (
    <IntranetLayout>
      <div className="mb-6 flex items-start justify-between gap-4">
        <div>
        <div className="flex items-center gap-3 mb-1">
          <Ship className="w-5 h-5 text-teal" />
          <h1 className="font-display text-2xl text-foreground">Vessel Catalogue</h1>
        </div>
        <p className="text-sm text-muted-foreground font-body mt-1">
          Vessels available for charter or newbuild — not currently contracted.
        </p>
        </div>
        <Link to="/fleet-brochure" target="_blank" className="inline-flex items-center gap-2 rounded-md border border-teal/40 px-3 py-2 text-xs font-semibold text-teal hover:bg-teal/10 whitespace-nowrap">
          <BookOpen className="w-4 h-4" /> Meet Our Fleet Brochure
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {VESSEL_CATALOGUE.map(v => (
          <CatalogueCard key={v.id} v={v} />
        ))}
      </div>
    </IntranetLayout>
  );
};

export default EmployeeVesselCatalogue;
